// utils/gtag.ts

const event = (
  action: string,
  params: any,
  param: { userId: string | null | undefined; lang: string | null | undefined }
) => {
  try {
    if ('gtag' in window) {
      params['user_id'] = param?.userId;
      params['locale'] = param?.lang;

      (window as any).gtag('event', action, params);
    }
  } catch (err) {
    console.log(err);
    console.log(action);
  }
};

export default event;
